<template>
  <center-layout-form title="ログイン">
    <template slot="outer">
      <el-dialog
        class="message-box"
        title="有効期限が迫っています"
        :visible.sync="bulkAlertDialog.visible"
        :close-on-click-modal="false"
        width="70%"
        :show-close="false"
        :close-on-press-escape="false"
      >
        <el-alert
          class="alert-area"
          type="error"
          :closable="false"
          show-icon>
          <div class = "text" >
            {{ bulkAlertDialog.message}} <br>
            {{ this.$config.alert_msg }}
          </div>
        </el-alert>

        <span slot="footer" class="dialog-footer">
          <el-button @click="onAlertClose()" >OK</el-button>
        </span>
      </el-dialog>
    </template>

    <template slot="body">
      <el-form
        v-if="isSupportBrowser"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="100px"
        autocomplete="off"
      >
        <el-form-item prop="username">
          <el-input
            size="large"
            v-model="form.username"
            :maxlength="1024"
            placeholder="ユーザ名"
            autofocus
          >
            <template slot="prepend">
              <i class="fa fa-user fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            size="large"
            type="password"
            v-model="form.password"
            :maxlength="1024"
            placeholder="パスワード"
            @keyup.enter.native="onSubmit('form')"
          >
            <template slot="prepend">
              <i class="fa fa-key fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item v-bind:class="{alert: isAlert}">
          <el-button
            size="large"
            class="login"
            type="primary"
            @click="onSubmit('form')"
            :loading="loading"
          >ログイン</el-button>
        </el-form-item>
        <el-alert v-if="isAlert" :title="errorMessage" type="error" show-icon :closable="false"></el-alert>
      </el-form>
    </template>
  </center-layout-form>
</template>

<script>
import axios from "axios";
import CenterLayoutForm from "@/components/CenterLayoutForm";

export default {
  components: {
    CenterLayoutForm
  },
  props: {
    isExtension: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    const endpointUrl = "/api/accounts/login/";
    return {
      endpointUrl,
      isAlert: false,
      loading: false,
      errorMessage: "",
      form: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "ユーザ名を入力してください",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "パスワードを入力してください",
            trigger: "blur"
          }
        ]
      },
      isSupportBrowse: false,
      bulkAlertDialog: {
        visible: false,
        message: "",
      }
    };
  },
  created() {
    this.initialize();
    this.isSupportBrowser = this.isChromeBrowser();
  },
  watch: {
    $route: "initialize"
  },
  methods: {
    initialize() {
      if (this.isExtension) {
        window.top.postMessage("loaded", "*");
      }
      axios.get(this.endpointUrl);
    },
    onSubmit(formName) {
      this.isAlert = false;
      this.loading = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios
            .post(this.endpointUrl, this.form)
            .then(response => {
              if(response.data.alert_flg){
                this.bulkAlertDialog.visible = true
                this.bulkAlertDialog.message = response.data.message
                this.loading = false;
              }
              else if (response.data.reset) {
                this.$router.push({
                  name: "changePassword",
                  query: this.$route.query
                });
              } else if ("next" in this.$route.query) {
                console.log(this.$route.query.next);
                window.location.href = this.$route.query.next;
              } else {
                this.$router.push({ name: "top" });
              }
            })
            .catch(error => {
              this.loading = false;
              if (error.response.status === 400) {
                if ("message" in error.response.data) {
                  console.log(error.response.data);
                  this.errorMessage = error.response.data.message;
                } else {
                  if (error.response.data.locked === true) {
                    this.errorMessage = "連続認証失敗によりロックされました";
                  } else {
                    this.errorMessage = "認証に失敗しました";
                  }
                }
                this.isAlert = true;
              } else if (error.response.status === 403) {
                this.errorMessage = error.response.data["detail"];
                this.isAlert = true;
              }
            });
        } else {
          return false;
        }
      });
    },
    isChromeBrowser() {
      let agent = window.navigator.userAgent.toLowerCase();
      if (agent.indexOf("edge") > -1) {
        return true;
      } else if (agent.indexOf("chrome") > -1) {
        return true;
      } else if (agent.indexOf("firefox") > -1) {
        return true;
      } else if (agent.indexOf("iphone") > -1) {
        return true;
      }
      return false;
    },
    onAlertClose(){
      if ("next" in this.$route.query) {
        console.log(this.$route.query.next);
        window.location.href = this.$route.query.next;
      } else {
        this.$router.push({ name: "top" });
      }
    }
  }
};
</script>

<style scoped>
.login {
  width: 100%;
}

.login-block {
  background-color: #fff;
  border: 1px solid #eaeefb;
  border-radius: 6px;
  padding: 32px 16px 8px 16px;
}

.el-form-item {
  padding-bottom: 4px;
}

.el-form-item.alert {
  margin-bottom: 4px !important;
}

.alert-area {
  width: 100%;
  height: 200px;
  margin: auto;
}

.alert-area >>> .el-alert__title {
  font-size: 20px;
}

.text {
  font-size: 20px;
}
</style>
